import { render, staticRenderFns } from "./CollapseItemConstruction.vue?vue&type=template&id=74385320&"
import script from "./CollapseItemConstruction.vue?vue&type=script&lang=js&"
export * from "./CollapseItemConstruction.vue?vue&type=script&lang=js&"
import style0 from "./CollapseItemConstruction.vue?vue&type=style&index=0&id=74385320&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports